import React, {createRef} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {gql, useLazyQuery} from "@apollo/client/index";
import Alert from "@material-ui/lab/Alert/Alert";
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PhoneIcon from '@material-ui/icons/Phone';
import BusinessIcon from '@material-ui/icons/Business';
import LocationOnIcon from '@material-ui/icons/LocationOn';

const useStyles = makeStyles((theme) => ({
    root: {

    },
    progress: {
        marginTop: -4
    },
    contactIcon: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 0,
        marginBottom: 0
    },
    contacts: {
        marginTop: 10,
        marginBottom: 10,
    },
    handle: {
        borderTop: '1px dashed #ccc'
    }
}));

const GET_DEALER_INFORMATION = gql`
  query($requestCode: String) {
    getDealerInformation(requestCode: $requestCode) {
        company
        phone
        address
        lat
        lon
    }
  }
`;

export default function GetDealerInformationAction(props) {

    const classes = useStyles();

    const bottomRef = createRef();

    const [loading, setLoading] = React.useState();

    const createBottomRef = (el) => {
        if (el) {
            //window.scrollTo(0, document.body.scrollHeight);
        }

        return bottomRef;
    };

    const [getDealerInformation, {loading: infoLoading, data: infoData, error: infoError}]
        = useLazyQuery(GET_DEALER_INFORMATION, {variables: {requestCode: props.request.code}});

    const handleOnChange = (e, expanded) => {
        if (expanded) {
            getDealerInformation();
        }
    };

    if (!loading && infoLoading) {
        setLoading(true);
    } else if (loading && !infoLoading) {
        setLoading(false);
    }

    return (
        <div className={classes.root}>
            <Accordion onChange={handleOnChange}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className={classes.heading}>Dealer Information</Typography>
                </AccordionSummary>
                <AccordionDetails className={classes.handle}>
                    {infoLoading ? <CircularProgress size={20}/> :
                        infoError ? <Alert severity={"error"}>Error! Please try again later.</Alert> :
                            infoData ?
                                <Typography className={classes.contacts}>
                                    <div>Reservation Code: <b>{props.request.code}</b></div>
                                    <div>Please mention <b>dashcarsales.com</b> when contacting the Dealer.</div>
                                    <div className={classes.contacts}>
                                        <div className={classes.contactIcon}>
                                            <BusinessIcon
                                                color="primary"  style={{
                                                paddingRight: '5',
                                            }}/>
                                            {infoData.getDealerInformation.company}
                                        </div>
                                        {infoData.getDealerInformation.phone ?
                                            <div className={classes.contactIcon}>
                                                <PhoneIcon color="primary"  style={{
                                                    paddingRight: '5',
                                                }}/>
                                                <a href={"tel:"+infoData.getDealerInformation.phone}>
                                                    {infoData.getDealerInformation.phone}
                                                </a>
                                            </div> : ''}
                                        <div className={classes.contactIcon}>
                                            <LocationOnIcon color="primary" style={{
                                                paddingRight: '5',
                                            }}/>
                                            {infoData.getDealerInformation.address}
                                        </div>
                                    </div>
                                    <div className={classes.map}>
                                        {/*<MapContainer lat={infoData.getDealerInformation.lat} lon={infoData.getDealerInformation.lon}/>*/}
                                    </div>
                                    <div ref={createBottomRef}> </div>
                                </Typography> : ''}
                </AccordionDetails>
            </Accordion>
        </div>
    );
}